import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import type { WorkDurationType } from "../../../../../../business/WorkDurationType.ts";
import type { Item } from "@/shared/components/generic/items.ts";
import useDisplayOptionsState from "@/pages/human-resources/time-management/model/display-options/useDisplayOptionsState.ts";
import useDisplayOptionsDispatch from "@/pages/human-resources/time-management/model/display-options/useDisplayOptionsDispatch.ts";
import FlatSelect from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/display-options/menu/flat-select/FlatSelect.tsx";

export default function ValorizedOrEffectiveDuration(): ReactNode {
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement.scheduleDisplayOptions.workDurationType",
  });
  const durationTypes: WorkDurationType[] = ["EFFECTIVE", "VALORIZED"];
  const items: Item<WorkDurationType>[] = durationTypes.map((u) => ({
    key: u,
    label: t(u.toLowerCase()),
    data: u,
  }));
  const { workDurationType } = useDisplayOptionsState();
  const { dispatch } = useDisplayOptionsDispatch();
  return (
    <FlatSelect
      title={t("title")}
      items={items}
      selectedItem={items.find((i) => i.data === workDurationType)}
      onSelectItem={(item) => {
        dispatch({
          type: "setWorkDurationType",
          durationType: item.data ?? "EFFECTIVE",
        });
      }}
    />
  );
}
